import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

// import logo from "../../assets/images/NPI Logo.png"
// import logoLightPng from "../../assets/images/logo-light.png"
// import logoLightSvg from "../../assets/images/NPI Logo.png"
// import logoDark from "../../assets/images/logo-dark.png"

const logo = "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FFavicon%20Pernod.png?alt=media&token=2005b833-9eec-4779-a831-9b68fa0be319"
const logoLightSvg = "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/SEES%20-%20constellation%20of%20us%2FFavicon%20Pernod.png?alt=media&token=2005b833-9eec-4779-a831-9b68fa0be319"

function tAdd() {
  var body = document.body
  body.classList.add("vertical-collpsed")
  // body.classList.add("sidebar-enable")
}

const Sidebar = props => {
    useEffect(()=>{
      tAdd()
    },[])
  return (
    <React.Fragment>
      <div
        className="vertical-menu newnav" style={{position:"fixed"}}>
        <div className="navbar-brand-box">
          <Link to="#" className="logo logo-dark">
            <span className="logo-sm">
              <img loading="lazy"  src={logo} alt="" height="65" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logoLightSvg} alt="" height="100" />
            </span>
          </Link>

          <Link to="#" className="logo logo-light">
            <span className="logo-sm">
              <img loading="lazy" src={logoLightSvg} alt="" height="65" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logoLightSvg} alt="" height="100" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
